import React, { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Layout from "../../pages/_layouts/default";

import Lottie from "react-lottie";
import warningAnimation from "../../lotties/warning.json";
import checkAnimation from "../../lotties/check.json";

import { Content, Title, DeliverButton, Controls, Text } from "./styled";
import api from "../../services/api";
import { toast } from "react-toastify";

export default function Deliver() {
  const [user, setUser] = useState(null);
  const [delivered, setDelivered] = useState(false);

  const defaultOptions = {
    loop: false,
    autoplay: true,
    animationData: !delivered ? warningAnimation : checkAnimation,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  const handleDeliver = useCallback(async (cpf) => {
    try {
      await api.patch(`deliveries/${cpf}`, { deliver: true });

      setDelivered(true);
    } catch (error) {
      toast.error(error.response.data.message);
    }
  }, []);

  const fetchMe = useCallback(async (cpf) => {
    const { data } = await api.get(`people/${cpf}`);

    setUser(data);
  }, []);

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const cpf = queryParams.get("cpf");

    fetchMe(cpf);
  }, [fetchMe]);

  return (
    <Layout>
      {!delivered ? (
        <Content>
          <Lottie options={defaultOptions} height={150} width={150} />
          <Title>
            Você deseja entregar o donativo a <span>{user?.name}</span> sob o
            CPF de número&nbsp;
            <span>{user?.cpf}</span> e nis <span>{user?.nis}</span>?
          </Title>
          <Controls>
            <DeliverButton onClick={() => handleDeliver(user?.cpf)}>
              Entregar Donativo
            </DeliverButton>
            <Link to="/">Voltar para o início</Link>
          </Controls>
        </Content>
      ) : (
        <Content>
          <Lottie options={defaultOptions} height={150} width={150} />
          <Title>Donativo entregue com sucesso!</Title>
          <Text>Você já pode fechar essa janela</Text>
        </Content>
      )}
    </Layout>
  );
}
